(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  if (!window.__bfCollectionDescriptionToggleBound) {
    window.__bfCollectionDescriptionToggleBound = true;

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-bf-collection-description-toggle]');
      if (!button) return;

      const shell = button.closest('[data-bf-collection-description]');
      const description = shell?.querySelector('[data-bf-collection-description-content]');
      const label = button.querySelector('[data-bf-collection-description-label]');
      if (!description) return;

      const expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
      description.classList.toggle('is-collapsed', expanded);

      if (label) {
        label.textContent = expanded ? 'Show more' : 'Show less';
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
